module.exports = __webpack_public_path__ + "static/img/qa.b314986b.svg";